import React from "react";
import { Button } from "./ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pagination({ page, pages, total, onChange }) {
  if (!pages || pages <= 1) {
    return <div className="text-xs text-slate-500 mt-3" data-testid="pagination-info">{total} resultados</div>;
  }
  return (
    <div className="flex items-center justify-between mt-4" data-testid="pagination">
      <div className="text-xs text-slate-500">Página {page} de {pages} · {total} resultados</div>
      <div className="flex gap-2">
        <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onChange(page - 1)} data-testid="pagination-prev">
          <ChevronLeft size={16} /> Anterior
        </Button>
        <Button variant="outline" size="sm" disabled={page >= pages} onClick={() => onChange(page + 1)} data-testid="pagination-next">
          Seguinte <ChevronRight size={16} />
        </Button>
      </div>
    </div>
  );
}
